import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import * as lodash from 'lodash-es';
import { DeviceService } from '../../device.service';
import { CommonService, TimeSource } from 'src/app/shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { UsersService } from 'src/app/users/users.service';
import { ColumnsConfig, TableConfig, TableData, CustomTableBackendData} from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { SCTCustomTable } from 'sct-custom-table/sct-table/projects/sct-table/src/lib/sct-table.component';
import { CommonDataService } from 'src/app/shared/services/common-data.service';
import { DeviceCommonService } from '../../device-common.service';
import { DeviceTypeService } from '../../device-type.service';
import { DeviceFactory } from '../../device-factory/device-factory';

@Component({
	selector: 'app-config-track',
	templateUrl: './config-track.component.html'
})
export class ConfigTrackComponent implements OnInit {
	@Input() device: any = {};
	@Input() currentSite: any;
	@Input() dateRange: {
		fromDate: Date,
		toDate: Date
	} = {
		fromDate: new Date(),
		toDate: new Date()
	};
	@Input() invalidDateRange: boolean = false;
	@ViewChild("sctCustomTable", { static: true }) sctCustomTable!: SCTCustomTable;
	@ViewChild("trackModal") trackModal;
	@ViewChild("compareModal") compareModal;

	@Output() updateAppearanceElementsFlags = new EventEmitter<any>(true);

	configsToCompare: any;
	gridColumns: any;
	trackModalData: any = {};
	compareModalData: any = {};
	arrayFields: string[] = [];
	objectFields: string[]	= [
		'mobile_master', 'mobile_network', 'router_network', 'online_network', 'ade90xx_settings',
		'window_0', 'window_1', 'window_2', 'window_3', 'window_4',
		'window_5', 'window_6', 'window_7', 'window_8', 'window_9'
	];
	nestedObjFields: string[] = ['mp_cal_high_range', 'mp_cal_low_range'];

	linksFields: string[] = ['last_saved_user_id', 'last_pm_user_id'];
	compareSkipFields: string[] = ['last_saved_user_id_link', 'last_pm_user_id_link'];

	imIpFields: string[] = [
		'static_ethernet_ip', 'static_ethernet_gw', 'static_ethernet_netmask',
		'static_wifi_ip', 'static_wifi_gw', 'static_wifi_netmask',
		'static_cellular_ip', 'static_cellular_gw', 'static_cellular_netmask'
	];
	imBandsFields: string[] = ['lte_cellular_bands', 'nbiot_cellular_bands'];

	imBooleanFields: string[] = [
		'enable_wifi_sta', 'enable_wifi_ap_on_start', 'enable_serversocket', 'enable_rt', 'enable_multicast',
		'enable_cellular', 'enable_ethernet', 'enable_load_schedule', 'enable_rt_average', 'disable_external_rtc',
		'in_test_mode', 'setup_done', 'setup_reset_data', 'reverse_energy_sign', 'modbus_enable',
		'system_ac_load_enable', 'system_aux_load_enable', 'user_ac_load_enable', 'user_aux_load_enable',
		'is_meter_subtracting', 'is_feeder_meter', 'sct_pre_configured', 'rt_check_enable',
		'ade_90xx_calibration_status', 'power_on_start', 'shipping_mode_enabled', 'battery_enable'
	];

	imFieldsLabels = {
		cell_acces_point_name: 'devices.cell_access_point_name',
		metered_connection: 'devices.metered_flag',
		event_logic: 'devices.events_type',
		zone_id: 'devices.zone_id'
	};

	imVoltageThresholdFields: string[] = ['over_voltage_threshold', 'under_voltage_threshold'];

	enabledWiresPhases = [
		{ bit: 0x1, label: 'quick_view.phase_a' },
		{ bit: 0x2, label: 'quick_view.phase_b' },
		{ bit: 0x4, label: 'quick_view.phase_c' }
	];

	columnConfig: ColumnsConfig[] = [];
	tableData: TableData[] = [];
	tableConfig: TableConfig = {
		hasExport: true,
		fileName: 'config-track',
		hasSelectionColumn: true,
		hasPagination: true,
		pageSize: 100,
		isBackendPagination: true,
		csvFileHeaderInfo: []
	};

	firstTime = true;
	isIMDevice = false;

	constructor(
		private deviceService: DeviceService,
		private commonService: CommonService,
		private translateService: TranslateService,
		private usersService: UsersService,
		private commonDataService: CommonDataService,
		private deviceCommonService: DeviceCommonService,
		private deviceTypeService: DeviceTypeService
	) { }

	/** Which time zone each time column is rendered in. See ST-2326. */
	private readonly timeSourceByColumn: Record<string, TimeSource> = {
		// Rendered as-is with no zone shift, so it stays a true UTC instant.
		insertion_time: TimeSource.Utc,
	};

	ngOnInit() {
		this.isIMDevice = DeviceFactory.isIMDeviceType(this.device?.config_info?.sct_device_type);
		this.columnConfig = [
			{ key: 'id', name: this.translateService.instant('g.id'), type: 'number'},
			{ key: 'memory_signature', name: this.translateService.instant('devices.memory_signature'), type: "number"},
			{ key: 'insertion_time', name: this.translateService.instant('g.insertion_time'), type: "date"},
			{ key: 'show_configs', name: this.translateService.instant('config.configs'), type: "action_link", hasSort: false, hasFilter: false},
		];
		this.commonService.applyTimeSourceTooltips(this.columnConfig, this.timeSourceByColumn);
		this.commonService.setPageTabTitle(
			`${this.currentSite.customer_name} - ${this.currentSite.name} - ${this.device.serial_number} - ${this.translateService.instant('nav.config_track')}`
		);

		this.tableConfig.csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({
			customerName: this.currentSite.customer_name,
			siteName: this.currentSite.name,
			deviceSN: this.device.serial_number,
			includeSpacing: false
		});
	}

	ngAfterViewInit() {
		this.getDeviceConfigTrack({currentPage: 1});
	}

	ngOnChanges(changes) {
		if (
			(changes.device && changes.device.previousValue && changes.device.previousValue.mac_address != changes.device.currentValue.mac_address) ||
			changes.dateRange
		) {
			if (!this.firstTime)
				this.getDeviceConfigTrack({currentPage: 1});

			this.firstTime = false;
		}
	}

	onTrackCellClicked(cycle) {
		this.trackModalData = this.formatChanges(cycle.configs);
		this.trackModal.show();
	}

	formatChanges(configs) {
		const deviceZoneId = this.device.config_info.zone_id ? this.device.config_info.zone_id : this.currentSite.zone_id;
		const zoneID = this.isIMDevice ? this.commonService.utcZoneId : deviceZoneId;
		return this.deviceService.formatQueuedChanges(this.device, configs, 'plainObject', zoneID);
	}

	getDeviceConfigTrack(paginationData) {
		paginationData = structuredClone(paginationData);
		if(!this.device.mac_address || this.invalidDateRange || !this.sctCustomTable)
			return;

		if(paginationData.currentPage == 1)
			this.sctCustomTable.backendPaginationInit();

		const limit = this.sctCustomTable.config.pageSize;

		let fromDateRange = this.dateRange.fromDate;
		let toDateRange = this.dateRange.toDate;
		fromDateRange = new Date(new Date(fromDateRange).setHours(0, 0, 0, 0));
		toDateRange = new Date(new Date(toDateRange).setHours(23, 59, 59, 999));

		let zoneDiff = new Date().getTimezoneOffset() * -1;
		let fromDate: any = new Date(new Date(fromDateRange).getTime() + (zoneDiff * 60 * 1000));
		let toDate: any = new Date(new Date(toDateRange).getTime() + (zoneDiff * 60 * 1000));
		fromDate = moment(fromDate).utc().startOf('day').unix();
		toDate = moment(toDate).utc().endOf('day').unix();

		const options = {
			currentPage: paginationData.currentPage,
			filters: paginationData.filters,
			sort: paginationData.sort,
			limit,
			fromDate,
			toDate,
		};

		if (options.filters?.insertion_time?.from) {
			options.filters.insertion_time.from = moment(options.filters?.insertion_time?.from).utc().unix() + (zoneDiff * 60);
		}

		if (options.filters?.insertion_time?.to) {
			options.filters.insertion_time.to = moment(options.filters?.insertion_time?.to).endOf('day').utc().unix() + (zoneDiff * 60);
		}

		this.deviceService.getDeviceConfigTrack(this.device.mac_address, options).subscribe((response: CustomTableBackendData) => {
			const tableData = [];
			this.tableData = [];

			response.data.forEach((record) => {
				record.insertion_time = moment(record.insertion_time * 1000).utc().format('MM/DD/YYYY HH:mm:ss');

				switch (record.configs.last_saved_user_id) {
					case null:
					case undefined:
						record.configs.last_saved_user_id = '---';
						break;
					case 0:
					case 0xFFFFFFFF:
						record.configs.last_saved_user_id = this.translateService.instant('g.system');
						break;
					default:
						if (this.usersService.hasAccessFunction('edit_user_admin'))
							record.configs.last_saved_user_id_link = `/user/edit/${record.configs.last_saved_user_id}`;

						record.configs.last_saved_user_id = `${record.configs.last_saved_user_id} - ${record.configs.last_saved_user_name}`;
						delete record.configs.last_saved_user_name;
						break;
				}

				if ('last_pm_user_id' in record.configs) {
					switch (record.configs.last_pm_user_id) {
						case 0:
						case 0xFFFFFFFF:
							record.configs.last_pm_user_id = this.translateService.instant('g.system');
							break;
						default:
							if (this.usersService.hasAccessFunction('edit_user_admin'))
								record.configs.last_pm_user_id_link = `/user/edit/${record.configs.last_pm_user_id}`;

							record.configs.last_pm_user_id = `${record.configs.last_pm_user_id} - ${record.configs.last_pm_user_name}`;
							delete record.configs.last_pm_user_name;
							break;
					}
				}

				this.formatSelectedFields(record.configs);

				tableData.push({
					id: { value: record.id },
					memory_signature: { value: record.memory_signature },
					show_configs: { value: this.translateService.instant('config.show_configs'), action: () => { this.onTrackCellClicked(record) } },
					insertion_time: { value: record.insertion_time },
					configs: { value: record.configs },
					mis_capacity_time: { value: record.mis_capacity_time },
					mis_voltage_time: { value: record.mis_voltage_time },
				});
			});

			this.tableData = tableData;
			this.sctCustomTable.updatePagination(response.totalDataCount)
		});
	}

	gridEvent(event: any) {
		if(event.length == 2) {
			this.configsToCompare = event.map((item: any) => {
				const newItem = {};
				for (const key in item) {
					newItem[key] = item[key].value || item[key];
				}
				return newItem;
			}).sort((a, b) => b.id - a.id);
		} else {
			this.configsToCompare = null;
		}
	}

	formatSelectedFields(recordConfigs) {
		for(const field of Object.keys(recordConfigs)) {
			switch(field) {
				case 'zone_id':
					if (this.isIMDevice)
						break;

					const timezone = this.commonDataService.TimeZonesMenu.find(zone => zone.id == recordConfigs[field]);
					if (timezone)
						recordConfigs[field] = timezone.display_name;
				break
				case 'cellular_region':
					const region = this.deviceCommonService.ddLists.cellular_region[recordConfigs[field]];
					if (region)
						recordConfigs[field] = region.text;
				break;
				case 'sct_device_type':
					// Convert device type integer to label
					const deviceTypeOption = this.deviceTypeService.options.find(option => option.id === recordConfigs[field])
						|| DeviceFactory.ImeterOptionsType.find(option => option.id === recordConfigs[field]);
					recordConfigs[field] = deviceTypeOption ? deviceTypeOption.name : recordConfigs[field];
				break;
				default:
					if (this.isIMDevice && this.formatImField(recordConfigs, field))
						break;

					if(this.deviceService.deviceBooleanFields.includes(field))
						recordConfigs[field] = !!recordConfigs[field];
				break;
			}
		}
	}

	formatImField(recordConfigs, field): boolean {
		if (this.imIpFields.includes(field)) {
			if (recordConfigs[field])
				recordConfigs[field] = this.commonService.int2ip(recordConfigs[field]);
			return true;
		}

		if (this.imBandsFields.includes(field)) {
			recordConfigs[field] = this.deviceCommonService.formatLteBands(field, recordConfigs[field]).join(', ');
			return true;
		}

		if (field == 'rt_log_frequency') {
			if (typeof recordConfigs[field] == 'number') {
				const [frequency, unit] = this.deviceService.formatRtLogFrequencyField(this.device.config_info, recordConfigs[field], true).split(' ');

				delete recordConfigs[field];
				recordConfigs.rt_log_frequency = frequency;
				recordConfigs.rt_log_frequency_unit = unit;
			}
			return true;
		}

		if (field == 'wiring_mode') {
			const wiringMode = this.deviceCommonService.ddLists.wiringModeSettings[recordConfigs[field]];
			if (wiringMode)
				recordConfigs[field] = wiringMode.text;
			return true;
		}

		if (field == 'enabled_wires') {
			const phases = this.enabledWiresPhases
				.filter(phase => recordConfigs[field] & phase.bit)
				.map(phase => this.translateService.instant(phase.label));

			if (phases.length)
				recordConfigs[field] = phases.join(' / ');
			return true;
		}

		if (field == 'metered_connection') {
			const meteredOption = this.deviceCommonService.ddLists.metered_flag.find(option => option.value == recordConfigs[field]);
			if (meteredOption)
				recordConfigs[field] = meteredOption.label;
			return true;
		}

		if (field == 'event_logic') {
			const isStateBased = recordConfigs[field] == this.deviceService.eventLogic.stateBased;
			const eventLogicKey = isStateBased ? 'devices.state_based_event_type' : 'devices.daily_event_type';
			recordConfigs[field] = this.translateService.instant(eventLogicKey);
			return true;
		}

		if (this.imBooleanFields.includes(field)) {
			recordConfigs[field] = !!recordConfigs[field];
			return true;
		}

		if (field == 'voltage_reference') {
			const option: any = Object.values(this.deviceCommonService.ddLists.voltageReferenceOptions)
				.find((item: any) => item.value == recordConfigs[field]);

			if (option)
				recordConfigs[field] = option.text;
			return true;
		}

		return false;
	}

	getConfigLabel(key) {
		if (this.isIMDevice) {
			if (this.imVoltageThresholdFields.includes(key))
				key += this.device.config_info.voltage_reference == this.deviceService.lineToLine ? '_ll' : '_ln';

			if (this.imFieldsLabels[key])
				return this.translateService.instant(this.imFieldsLabels[key]);

			const imKey = 'iotemeter.devices.' + key;
			const imLabel = this.translateService.instant(imKey);
			if (imLabel !== imKey)
				return imLabel;
		}
		return this.translateService.instant('devices.' + key);
	}

	compareConfigs() {
		let oldConfig		= {};
		let oldValsIdx		= 1;
		let newConfig		= lodash.cloneDeep(this.configsToCompare[0].configs);
		let ignoreFields	= ['memory_signature'];
		let fieldsToShowBothConfig = ['last_saved_user_id', 'last_saved_user_id_link'];

		if(this.configsToCompare[1].configs.memory_signature > this.configsToCompare[0].configs.memory_signature) {

			newConfig	= lodash.cloneDeep(this.configsToCompare[1].configs);
			oldValsIdx	= 0;
		}

		for(let key in newConfig) {
			if(ignoreFields.includes(key))
				continue;

			const handleNestObj = (tempOld, newConfig) => {
				if(tempOld && newConfig) {
					let hasDifference = false;
					let tempObj = {};
					for(let subKey in tempOld) {
						if(tempOld[subKey] != newConfig[subKey]) {
							tempObj[subKey] = tempOld[subKey];
							hasDifference = true;
						} else {
							delete newConfig[subKey];
						}
					}
					if(hasDifference) {
						oldConfig[key] = lodash.cloneDeep(tempObj);
					}
				}
			}
			let tempOld = this.configsToCompare[oldValsIdx].configs[key];
			if(this.objectFields.includes(key)) {
				handleNestObj(tempOld, newConfig[key]);

			} else if(this.arrayFields.includes(key)) {

				if(tempOld && newConfig[key] && !this.commonService.arrayCompare(tempOld, newConfig[key]))
					oldConfig[key] = tempOld;

			}else if (this.nestedObjFields.includes(key)) {
				handleNestObj(oldConfig[key], newConfig[key]);
			}
			else if(fieldsToShowBothConfig.includes(key) || tempOld != newConfig[key]) {

				oldConfig[key] = tempOld;
			}
		}

		this.compareModalData = {
			'old': this.formatChanges(oldConfig),
			'new': this.formatChanges(newConfig)
		};

		this.compareModal.show();
	}

	isObject(value) {
		return typeof value == 'object' && value && Object.keys(value).length > 0;
	}

	hideModals() {
		this.compareModal.hide();
		this.trackModal.hide();
	}
}
